import axios from 'axios'

const getUrlParams = () => {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const params = Array.from(urlParams.entries())

  if (params.length) {
    return {
      k: urlParams.has('k') ? urlParams.get('k') : null,
      q: urlParams.has('q') ? urlParams.get('q') : null,
      s: urlParams.has('s') ? urlParams.get('s') : null,
      u: urlParams.has('u') ? urlParams.get('u') : null,
    }
  }
  return {}
}

export const getScanData = async () => {
  const SCANTRUST_URL = `${process.env.REACT_APP_QR_BRIDGE}`
  const params = getUrlParams()
  const headers = {
    'Content-Type': 'application/json',
  }
  try {
    // Avoid wrong call to qr-bridge if api key not provided
    if (!params.k) {
      return { data: { data: { scanParamQ: null } } }
    }
    const { data } = await axios.get(SCANTRUST_URL, {
      headers,
      params,
    })

    data.data.scanParamQ = params.q

    if (!data) {
      return null
    }

    return data
  } catch (error) {
    console.error(error)
  }
}

export const getProduct = id => {
  const products = {
    '001': 'Fusion Water',
    '002': 'Fusion Water Urban',
    '003': 'Fusion Water Color',
    '004': 'Fusion Water Pediatrics',
    '005': 'Age Repair',
    '006': 'Age Repair Color',
    '007': 'Age Repair',
    '008': 'Fusion Water',
    '009': 'Fusion Water Color',
    '010': 'Fusion Water Color',
    '011': 'Fusion Water Color',
    '012': 'Isdinceutics Melaclear',
    '013': 'Fusion Water Pediatrics',
    '014': 'Fusion Gel Sport',
    '015': 'Flavo-C Forte',
    '016': 'Flavo-C Forte',
    '017': 'Fotoprotector ISDIN',
    '018': 'Spot Prevent',
    '019': 'Active Unify',
    '020': 'Active Unify Color',
    '021': 'Isdin Woman Antiestrías',
    '022': 'Isdin Woman Reafirmante',
    '024': 'After Sun Lotion',
    '025': 'After Sun Lotion',
    '026': 'Germisdin Intim Calm',
    '027': 'Germisdin Intim Calm',
    '028': 'Germisdin Intim Higiene Intima',
    '029': 'Germisdin Intim Higiene Intima',
    '030': 'Fusion Fluid',
    '031': 'Isdin Deo Ultra 72H',
    '032': 'Teen Skin Acniben Toallitas',
    '033': 'Si-Nails',
    '034': 'Isdinceutics Glicoisdin 8',
    '035': 'Isdinceutics Glicoisdin 10',
    '036': 'Isdinceutics Glicoisdin 15',
    '037': 'Isdinceutics Glicoisdin 15',
    '038': 'Isdinceutics Glicoisdin 25',
    '039': 'Isdinceutics A.G.E Reverse Day',
    '040': 'Isdinceutics A.G.E Reverse Night',
    '041': 'Uv Mineral Brush On The Go',
    '042': 'Baby Naturals Zn40',
    '043': 'Transparent Spray',
    '044': 'Transparent Spray',
    '045': 'Transparent Spray Pediatrics',
    '046': 'Lotion Spray',
    '047': 'Lotion Spray Pediatrics',
    '048': 'Gel Cream',
    '049': 'Gel Cream',
    '050': 'Gel Cream Pediatrics',
    '051': 'Gel Cream',
    '052': 'After Sun Spray',
    '053': 'Hydrolotion',
    '054': 'Hydrooil',
    '055': 'Isdinceutics Triple Clarity',
    '056': 'Isdinceutics K-Ox Eyes',
    '057': 'Isdinceutics Hyaluronic Concentrate',
    '058': 'Isdin Woman Hidratante Intimo Vulvar',
    '059': 'Isdinceutics Vital Eyes',
    '060': 'Pasta Bexident Dientes Sensibles',
    '061': 'Germisdin Gel Hidroalcoholico',
    '062': 'Fusion Fluid Mineral',
    '063': 'Pasta Bexident Dientes Sensibles',
    '064': 'Pasta Bexident Dientes Sensibles',
    '065': 'Baby Naturals',
    '066': 'Fotoprotector Extrem',
    '067': 'Mineral Brush Facial Powder',
    '068': 'Pasta Bexident Encías Uso Diario',
    '069': 'Isdinceutics Flavo-C Serum',
    '070': 'Isdinceutics Flavo-C Serum',
    '071': 'Nutradeica Gel Crema Facial',
    '072': 'Pasta Bexident Encías Uso Diario',
    '073': 'Pasta Bexident Encías Uso Diario',
    '074': 'Germisdin Aloe Vera',
    '075': 'Germisdin Aloe Vera',
    '076': 'Germisdin Aloe Vera',
    '077': 'Nutratopic Pro-Amp Locion Corporal',
    '078': 'Nutratopic Pro-Amp Gel De Baño',
    '079': 'Fotoprotector ISDIN',
    '080': 'Gel Bexident Encias',
    '088': 'Bienvenido ISDIN',
    '089': 'Producto de bienvenida',
    '090': 'Fotoprotector Sun ISDIN Cápsulas',
    '091': 'ISDIN Woman Higiene Íntima',
    '092': 'Código QR ISDIN',
    '097': 'Test QR',
    '102': 'QR de bienvenida a la Comunidad',
    '107': 'Regalo No Community, No Party!',
    '108': 'Producto regalo Welcome pack evento Yoga',
    '109': 'Producto regalo Welcome pack evento Pilates',
  }

  if (products[id]) {
    return products[id]
  }
  return 'Fotoprotector ISDIN'
}
